import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetAllArchivedProjectsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      PROJECT_NAME = "PROJECT_NAME",
      CREATED_ON = "CREATED_ON",
      LAST_MODIFIED = "LAST_MODIFIED",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetAllArchivedProjectsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "PROJECT_NAME":
          return ColumnName.PROJECT_NAME;
        case "CREATED_ON":
          return ColumnName.CREATED_ON;
        case "LAST_MODIFIED":
          return ColumnName.LAST_MODIFIED;
        default:
          throw new InvalidGetAllArchivedProjectsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetAllArchivedProjectsSortOrderDTO {
  sortIndex: number;
  columnName: GetAllArchivedProjectsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetAllArchivedProjectsSortOrder {
  readonly isGetAllArchivedProjectsSortOrderGetAllArchivedProjectsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetAllArchivedProjectsSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetAllArchivedProjectsSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetAllArchivedProjectsSortOrderDTO): GetAllArchivedProjectsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetAllArchivedProjectsSortOrderSortIndexError);
    const columnName = GetAllArchivedProjectsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetAllArchivedProjectsSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetAllArchivedProjectsSortOrderOrderError));
    return new GetAllArchivedProjectsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetAllArchivedProjectsSortOrderDTO {
    const dto: GetAllArchivedProjectsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetAllArchivedProjectsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetAllArchivedProjectsSortOrder.prototype.toString = function toString(): string {
  return `GetAllArchivedProjectsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetAllArchivedProjectsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderError";
  }
}
export class InvalidGetAllArchivedProjectsSortOrderSortIndexError extends InvalidGetAllArchivedProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderSortIndexError";
  }
}

export class InvalidGetAllArchivedProjectsSortOrderColumnNameError extends InvalidGetAllArchivedProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderColumnNameError";
  }
}

export class InvalidGetAllArchivedProjectsSortOrderColumnNameProjectNameError extends InvalidGetAllArchivedProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderColumnNameProjectNameError";
  }
}

export class InvalidGetAllArchivedProjectsSortOrderColumnNameCreatedOnError extends InvalidGetAllArchivedProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderColumnNameCreatedOnError";
  }
}

export class InvalidGetAllArchivedProjectsSortOrderColumnNameLastModifiedError extends InvalidGetAllArchivedProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderColumnNameLastModifiedError";
  }
}

export class InvalidGetAllArchivedProjectsSortOrderOrderError extends InvalidGetAllArchivedProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllArchivedProjectsSortOrderOrderError";
  }
}
